import { useQuery } from 'react-query'

import { healthCheckService } from 'src/services/health-check.service'
import { QUERY_KEYS } from 'src/constants'

export const useHealthCheck = () => {
  return useQuery([QUERY_KEYS.HEALTH_CHECK], () => healthCheckService.ping(), {
    keepPreviousData: true,

    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: 5 * 60 * 1000,
  })
}
